import React from "react";
import CodeExample from "../../partials/content/CodeExample";
import { TextField,MenuItem,InputLabel,Select,IconButton,Button } from '@material-ui/core';
import {getLocations,getUserByToken,getInventories,getMaster,getScreenFields ,getInventoriesExport,updateScan,bulkUpdateScan} from "../../crud/auth.crud";

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import Pagination from "react-js-pagination";
import {  format } from 'date-fns'
import Chip from '@material-ui/core/Chip';


import "../../customCss/SuperResponsiveTableStyle.css";
import "../../customCss/Pagination.css";

import EditIcon from '@material-ui/icons/Edit';

import Autocomplete from '@material-ui/lab/Autocomplete';

import HighlightOffIcon from '@material-ui/icons/HighlightOff';
 import { Link } from "react-router-dom";

 import { Bounce } from 'react-activity';
import 'react-activity/dist/react-activity.css';

import { Formik } from "formik";

import ToggleOnOutlinedIcon from '@material-ui/icons/ToggleOnOutlined';
import ToggleOffOutlinedIcon from '@material-ui/icons/ToggleOffOutlined';
import { Alert } from '@material-ui/lab'; 
import Checkbox from '@material-ui/core/Checkbox';

import Grid from "../../partials/content/Grid";
import RoomIcon from '@material-ui/icons/Room';


import CircularProgress from '@material-ui/core/CircularProgress';


import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import Icon from '@material-ui/core/Icon';

import { Tooltip } from "@material-ui/core";
import { ThreeSixtyOutlined, TramRounded } from "@material-ui/icons";






export default class Inventories extends React.Component {
  state = {
    users:[],
    toCount :0,
    activePage:1,
    pageSize:10,
    totalCount:0,
    updateStatus:false,
    statusColor:'',
    statusMessage:'',
    filterFields :{},
    fields:[],
    filter:false,
    sortField :'',
    sortDir:'asc',
    open:false,
    currentUser:"",
	postObj:{},
	filter:false,
	isReset:false,
	isLoading:false,
	selectedInventory: null,
	selected: [],
	showBulkTransfer:false,
	summaries:[],
	locations:[],
  }
  GlobalHeader = "User";
 
  handleDeleteDialog = (inventory) => {

	if (window.confirm("Are you sure you want to delete this scan document?")) {
      // Perform deletion logic
	 	 //this.setState({currentUser:userId})

	let postObj = {
														isActive: false,
														isDeleted: true
													}
								 
														   updateScan(
															 inventory.id,
															 postObj 
														   )
															 .then(resp => {
															   
															 
																/*let inventories = [];
																inventories = this.state.users;
																//.log("aaal locatiokns:::",locations);
																let index = inventories.findIndex(el => el.id == inventory.id);
																console.log("index",index);
																delete inventories(index);

																this.setState({users:inventories});*/

																getInventories(this.state.activePage,this.state.pageSize,this.state.sortField,this.state.sortDir)//.then(response => response.data)
	    .then((response) => {
	 		this.setState({totalCount:parseInt(response.headers["x-total-records"])});
	        this.setState((state)=>({toCount : state.activePage*state.pageSize<=state.totalCount?state.activePage*state.pageSize:state.totalCount}));
	        this.setState({ users: response.data });
	     });

																//alert("Scan document deleted s ")
																


					 
															 })
															 .catch(() => {
															  
															   //this.setState({loading:false,isSubmitting:false});
															 })
														   		 
    } else {
      // Handle cancellation
    }
    
    
    //alert(userId);

  };

  handleClose = () => {
    this.setState({open:false})
  };


    handleTransferClose = () => {
    this.setState({showBulkTransfer:false})
  };


  handleQuantityChange=(e,summary)=>{
    /* console.log("handle chnage ::::",summary);
    let cost = parseFloat(summary.productPrice) * (parseFloat(e.target.value)+summary.totalQuantity);
    this.setState({[`summary_${summary.productKey}`]:e.target.value});
    let alllist = this.state.summaries;
    let productIndex = alllist.findIndex(el => el.productKey == summary.productKey);
    alllist[productIndex] = {...alllist[productIndex], totalCost: cost};

    let total = 0;
    alllist.map((asd)=>{
      total = parseInt(total) + parseInt(asd.totalCost);
    })
    this.setState({summaries:alllist,total:total});
*/
  }


constructor(props)
{
	super(props);
	this.handleSort = this.handleSort.bind(this);
}

handleEditDialog(inventory)
{

	this.setState({open:true,status:false,selectedInventory:inventory});
}



  handlePageSizeChange(option) {
  	let currentPage = 1;
  	 	
  	 	if(this.state.toCount<option.target.value) 
  	 		currentPage = 1;
		else if(parseInt(this.state.toCount/option.target.value)==(this.state.toCount/option.target.value))
			currentPage = 	parseInt(this.state.toCount/option.target.value)
		else
			currentPage=parseInt(this.state.toCount/option.target.value)+1;

			this.setState({activePage: currentPage,pageSize: option.target.value},
				 () => {
					getInventories(this.state.activePage,this.state.pageSize,this.state.sortField,this.state.sortDir,this.state.postObj)///.then(response => response.data)
				    .then((response) => {
				        this.setState({ users: response.data,selected:[] });
				 		this.setState({totalCount:response.headers["x-total-records"]});
				        this.setState((state)=>({toCount : state.activePage*state.pageSize<=state.totalCount?state.activePage*state.pageSize:state.totalCount}));
				     })
				}
				)
  }

  handlePageChange(pageNumber) {
    
     getInventories(pageNumber,this.state.pageSize,this.state.sortField,this.state.sortDir,this.state.postObj)//.then(response => response.data)
    .then((response) => {
    	
        this.setState({ users: response.data });
 		this.setState({activePage: pageNumber,selected:[]})	
 		this.setState({totalCount:response.headers["x-total-records"]});
        this.setState((state)=>({toCount : state.activePage*state.pageSize<=state.totalCount?state.activePage*state.pageSize:state.totalCount}));
     })
  }
 

  handleSort(fieldName)
  {
  	        this.setState((state)=>({sortField:fieldName,sortDir:state.sortDir=='asc'?'desc':'asc'}));
  	        //alert(fieldName+ "  "+this.state.sortDir);

  	        getInventories(this.state.activePage,this.state.pageSize,fieldName,this.state.sortDir,this.state.postObj)//.then(response => response.data)
			    .then((response) => {
			 		this.setState({totalCount:response.headers["x-total-records"]});
			        this.setState((state)=>({toCount : state.activePage*state.pageSize<=state.totalCount?state.activePage*state.pageSize:state.totalCount}));
			        this.setState({ users: response.data,selected:[] });
			     });
  }
  handleFilter(event)
  {
  	let postObj={};
  	//console.log(this.state.fields.fields);

  	this.state.fields[0].fields.map((field)=> {
  			
  			if(this.state[`Filter_${field.fieldName}`]!=undefined && this.state[`Filter_${field.fieldName}`]!='')
  			{
				if(field.dataType==="String")
					postObj['search'+field.fieldName]=this.state[`Filter_${field.fieldName}`];
  				else if(field.dataType==="lookup")
  				 	postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
  				 else
  				 	postObj[field.fieldName]=this.state[`Filter_${field.fieldName}`];
  			}

  			})
  			this.setState({activePage:1})
  		   getInventories(1,this.state.pageSize,this.state.sortField,this.state.sortDir,postObj)//.then(response => response.data)
			    .then((response) => {
			 		this.setState({totalCount:response.headers["x-total-records"],postObj:postObj});
			        this.setState((state)=>({toCount : state.activePage*state.pageSize<=state.totalCount?state.activePage*state.pageSize:state.totalCount}));
			        this.setState({ users: response.data,selected:[] });
			     });	
  }
  handleReset(event)
  {
	console.log("rest");
	let postObj={};
	//this.state.filter=false;
	this.setState({isReset:true});
						//this.setState({filter:false},function(){
			  //this.setState({filter:true})		
			  //})
	 this.state.fields[0].fields.map((field)=> {
		
		if(field.dataType!=='lookup')
		{
			this.setState({[`Filter_${field.fieldName}`]:''});
		}
		if(field.dataType==='lookup')
		{
			//this.setState({[field.fieldName]:[]});
			this.setState({[`Filter_${field.fieldName}`]:''});
		}

		})

  			this.setState({activePage:1})
  		   getInventories(1,this.state.pageSize,this.state.sortField,this.state.sortDir,postObj)//.then(response => response.data)
			    .then((response) => {
			 		this.setState({totalCount:response.headers["x-total-records"],isReset:false});
			        this.setState((state)=>({toCount : state.activePage*state.pageSize<=state.totalCount?state.activePage*state.pageSize:state.totalCount}));
			        this.setState({ users: response.data,selected:[] });
	     });	
  }
  async componentDidMount()
  {

	//side menu collapse
	 if ( !document.body.classList.contains("kt-aside--minimize"))
	 {
			  //removeCSSClass(document.body, "kt-aside--minimize");
			  document.body.classList.add("kt-aside--minimize");
	}

	 getUserByToken().then(response => response.data)
		.then((data) => {
	  getLocations(1,100,'locationName','asc',{accountKey:data[0].accountKey})
		  .then((response) => {
			this.setState({ locations:response.data})
			//locations = response.data;
			//console.log("locations:::::",response.data);
		   });
		}
	);
	 
	

  	await getScreenFields('inventory')
  	.then((fieldResponse) => {


  		
  		

  		fieldResponse.data[0].fields
  			.filter((fieldFilter) => fieldFilter.dataType==='lookup')
  			.map((fieldMap)=>
  					{
  							getMaster(fieldMap.lookUp.lookupName)
							.then((filterResponse)=>
								{
									this.setState({[fieldMap.fieldName]:filterResponse.data});

								})
						}
  					
  				)


				  this.setState({fields:fieldResponse.data,filter:true});

				  //console.log("fieldResponse",fieldResponse.data)
    });
			
	getInventories(this.state.activePage,this.state.pageSize,this.state.sortField,this.state.sortDir)//.then(response => response.data)
	    .then((response) => {
	 		this.setState({totalCount:parseInt(response.headers["x-total-records"])});
	        this.setState((state)=>({toCount : state.activePage*state.pageSize<=state.totalCount?state.activePage*state.pageSize:state.totalCount}));
	        this.setState({ users: response.data });
	     });

  }

  exportClick(event)
	{
		
	
			let postObj={};
  	//console.log(this.state.fields.fields);

  	this.state.fields[0].fields.map((field)=> {
  			
  			if(this.state[`Filter_${field.fieldName}`]!=undefined && this.state[`Filter_${field.fieldName}`]!='')
  			{
				if(field.dataType==="String")
					postObj['search'+field.fieldName]=this.state[`Filter_${field.fieldName}`];
  				else if(field.dataType==="lookup")
  				 	postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
  				 else
  				 	postObj[field.fieldName]=this.state[`Filter_${field.fieldName}`];
  			}

  			})
			   
				getInventoriesExport(postObj)
						.then((response) => {
						  if(response.data!=""){
							var win = window.open(response.data, '_blank');
								win.focus();}
								else
									alert('Error exporting records')
						})
	}

  autocompleteOnChange=(event,newValue,fieldName,lookupKey) => {
	if(event!==null && newValue!==null)
	{
	  console.log("autocomplete change:::",event ,newValue,fieldName,lookupKey,newValue[lookupKey]);
	  this.setState({[fieldName]:newValue[lookupKey]});
	}
	
  }

      toggleSelect = (id) => {
    let selected = [...this.state.selected];
    if (selected.includes(id)) {
      selected = selected.filter((x) => x !== id);
    } else {
      selected.push(id);
    }
    this.setState({ selected }); // ✅ no prevState
  };

  toggleSelectAll = () => {
    const { selected } = this.state;
    this.setState({
      selected: selected.length === this.state.users.length ? [] : this.state.users.filter(x=>x.description!==null && x.description!=="" && x.description.toLowerCase()!=="n/a" && x.approvedStatus!==true).map((row) => row.id)
    });
  };

   handleApprove = () => {
    //alert(`Approved IDs: ${this.state.selected.join(", ")}`);

	let postObj = 
		this.state.selected;
	

	bulkUpdateScan(postObj)
	.then((response) => {

		
			const updatedItems = this.state.users.map(item => {
    		const match = this.state.selected.find(sel => sel === item.id); // exact id match
    		return match ? { ...item, approvedStatus: true} : item;
  			});
		
							
		this.setState({ users: updatedItems,selected: [] }); // optional clear
						
	})
  
  };


  showTransfer = () =>{
	let summary =[];
	console.log("trasfer ............",this.state.selected);
	 this.state.users!==null && this.state.users.length>0 &&  this.state.users.map((x)=>{
		if (this.state.selected.includes(x.id))
		{
				summary.push(x);
		}
	 });
			
		


	 console.log("trasfer summary............",summary);
	this.setState({showBulkTransfer:true,summaries:summary});

  }

  handleTransfer = () => {
    //alert(`Approved IDs: ${this.state.selected.join(", ")}`);

	let postObj = 
		this.state.selected;
	

	bulkUpdateScan(postObj)
	.then((response) => {

		
			const updatedItems = this.state.users.map(item => {
    		const match = this.state.selected.find(sel => sel === item.id); // exact id match
    		return match ? { ...item, approvedStatus: true} : item;
  			});
		
							
		this.setState({ users: updatedItems,selected: [] }); // optional clear
						
	})
  
  };


  autocompleteOnInputChange=async (event,value,fieldName,lookupKey,lookupName) =>  {
	if(event!==null && value!==null && value.length>3)
	{
	//  console.log("autocomplete input change:::",event ,fieldName,lookupKey);
	  //console.log("autocomplete input change:::",event ,value,fieldName,lookupKey);
	  //this.setState({[fieldName]:newValue[lookupKey]});
	  //var postObj = {
      //  nameLowerCase: value.toLowerCase()
        
      //};
      //let accountData=[];

	 // this.state[fieldName].filter(x=>x.accountName.toLowerCase().includes(value.toLowerCase())).map((p) => {
	  
	//	accountData.push(p)

	 // });
    
    	
              //this.setState({ [fieldName]:accountData});
       /*await getMaster(lookupName)
		.then((filterResponse)=>
		{
			this.setState({[fieldName]:filterResponse.data});
		});*/
	}
	
  }
  
 

  render() {
	//console.log(this.state.fields);
    return (
      <>
    <div>
	
		
        <div className="row">
          <div className="col-md-12">
            <CodeExample beforeCodeTitle="Inventory Stock Intake" jsCode="true" csv ="true" exportClick={this.exportClick.bind(this)} >
              <div className="kt-section">
 
			 

               {this.state.updateStatus && (
						<Alert severity="success">{this.state.statusMessage}</Alert>
				  )}
			{
      	 
<div>
	
<div className="row">

	
	  {
		this.state.fields.map((screen) => (
			screen.fields.map((field)=>{
			  
				  if(field.dataType==='String')
				  
				  return(
					  	<div className="col-lg-6" key={field.fieldName}>
						   <TextField fullWidth name={field.fieldName} label={field.displayName}
						     value={this.state[`Filter_${field.fieldName}`]}
									 onChange={e=>this.setState({[`Filter_${field.fieldName}`]:e.target.value})}
									 />
						</div>
					  
				  )
				  
					else if(field.dataType==='checkbox')
							
							return(
								<div className="col-lg-6" key={field.fieldName}>
						    	{field.displayName} <Checkbox name={field.fieldName} value={true} onChange={e=>this.setState({[`Filter_${field.fieldName}`]:!this.state[`Filter_${field.fieldName}`]})} />
					         </div>
					         )	
				 
				  else if(field.dataType==='lookup')
					  return(
						<div className="col-lg-6" key={field.fieldName}>
							   <Autocomplete
								  id={field.lookUp.lookupKey}
								  name={field.lookUp.lookupKey}
								  value={this.state[`Filter_${field.fieldName}`]}
								  options={this.state[field.fieldName]}
								  autoComplete={true}
								  clearOnBlur={true}
								  getOptionLabel={(option) => option[field.lookUp.lookupDisplay]}
								  onChange={(event,newValue)=>{this.autocompleteOnChange(event,newValue,`Filter_${field.fieldName}`,field.lookUp.lookupId);}}
								  onInputChange={(event,value)=>{this.autocompleteOnInputChange(event,value,field.fieldName,field.lookUp.lookupId,field.lookUp.lookupName);}}						
								  renderInput={(params) => <TextField {...params} label={field.displayName}  />}
							  />
							  </div>
						   
				  )
				 
				 
			  
			  }) //{/* map  inner loop close*/}
		  )) //{/* map loop close*/}
  }

</div>
  <div className="row">
	  
	  
	  <Button
	  variant="outlined"
	  color="primary"
	  onClick={this.handleFilter.bind(this)}
	  endIcon={<Icon>search</Icon>}
	  style={{'padding':'10px','margin':'10px'}}
	  >
	  {
		  this.state.isLoading==true&&<><Bounce /></>
	  }
	  {
		  this.state.isLoading==false&&<>Apply Filter</>
	  }</Button>
	  
	  <Button
	  variant="outlined"
	  color="primary"
	  onClick={this.handleReset.bind(this)}
	  endIcon={<Icon>backspace</Icon>}
	  style={{'padding':'10px','margin':'10px'}}
	  >
	  {
		  this.state.isReset==true&&<><Bounce /></>
	  }
	  {
		  this.state.isReset==false&&<>Reset Filter</>
	  }
	  </Button>
	 

 </div>
	</div>

  }



      
		</div>
		</CodeExample>
		</div>
		</div>

		  <Alert severity="warning">{'Alert - Description not available will not be updated in the database'}</Alert>
				  


			<div className="kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded" id="kt_apps_user_list_datatable">
				{/* ✅ Bulk Actions Toolbar */}
       {this.state.selected.length > 0 && (
          <div className="flex justify-end">

			 
	  <Button
	  variant="outlined"
	  color="primary"
	  onClick={this.handleApprove}
	  
	  style={{'padding':'10px','margin':'10px'}}
	  >
	  Bulk Approve ({this.state.selected.length})
	 </Button> 

	   <Button
	  variant="outlined"
	  color="primary"
	  onClick={this.showTransfer}
	  
	  style={{'padding':'10px','margin':'10px'}}
	  >
	  Bulk Transfer ({this.state.selected.length})
	 </Button>
	  
</div>
           
        )}
      	   <Table >
		    <Thead >
		    <Tr >
				  <Th>
					
            <input
              type="checkbox"
              checked={this.state.selected.length === this.state.users.filter(x=>x.description!==null && x.description!=="" && x.description.toLowerCase()!=="n/a" && x.approvedStatus!==true).length}
              onChange={this.toggleSelectAll}
            />
          </Th>
		    {
		    	this.state.fields.map((screen) => (
		    		screen.fields.map((field)=>{
					if(field.displayName!='Action' && field.isDummy !==true)
						return(<Th onClick={this.handleSort.bind(this,field.fieldName)}>
						
						<span className='headerSpan' style={{cursor:'pointer'}}>
							{field.displayName}&nbsp;
							{
								field.fieldName===this.state.sortField && this.state.sortDir==='desc' &&
							<i className="flaticon2-arrow-up"></i>
							}
							{
								field.fieldName===this.state.sortField && this.state.sortDir==='asc'&& 
							<i className="flaticon2-arrow-down"></i>
							}
							</span>
							</Th>)
							
							if(field.displayName==='Action')
								return(
								<Th onClick={this.handleSort.bind(this,'approvedStatus')}>
								<span className='headerSpan' style={{cursor:'pointer'}}>
							{field.displayName}&nbsp;
							{
								this.state.sortField==="approvedStatus" && this.state.sortDir==='desc' &&
							<i className="flaticon2-arrow-up"></i>
							}
							{
								this.state.sortField==="approvedStatus" && this.state.sortDir==='asc'&& 
							<i className="flaticon2-arrow-down"></i>
							}
							</span>
								</Th>)
		    			})
		    		))
		    }
			<Th>Utilized</Th>
			<Th>Available</Th>
			<Th onClick={this.handleSort.bind(this,'approvedStatus')}>
								<span className='headerSpan' style={{cursor:'pointer'}}>
							Action &nbsp;
							{
								this.state.sortField==="approvedStatus" && this.state.sortDir==='desc' &&
							<i className="flaticon2-arrow-up"></i>
							}
							{
								this.state.sortField==="approvedStatus" && this.state.sortDir==='asc'&& 
							<i className="flaticon2-arrow-down"></i>
							}
							</span>
								</Th>
		    </Tr>
		   
		       
		    </Thead>
		    <Tbody>
		  { this.state.isLoading &&
			<div style={{alignItems: "center",display: 'flex', justifyContent: 'center'}}>                            
										<Alert icon={<CircularProgress size={15} />}>&nbsp;&nbsp;Progressing.Please wait.</Alert>      
									  </div>}
					{
						this.state.users.map((inv)=>(
						<Tr key={inv.id}>
							<Td>
								{inv.description!==null && inv.description!=="" && inv.description.toLowerCase()!=="n/a" && inv.approvedStatus!==true &&
							<input
								type="checkbox"
								checked={this.state.selected.includes(inv.id)}
								onChange={() => this.toggleSelect(inv.id)}
							/>}
							</Td>
							<Td>{inv.description}</Td>
							<Td>{inv.expiryDate!==null && format(new Date(inv.expiryDate.substring(0,10)),"MM-dd-yyyy")}</Td>
							<Td>{inv.lastUpdatedOn!==null &&
								<>
								 {inv.lastUpdatedOn.substring(5,7)+'-'+inv.lastUpdatedOn.substring(8,10)
							+"-"+inv.lastUpdatedOn.substring(0,4) +' '+inv.lastUpdatedOn.substring(11,16)}
								</>
								}</Td>
							<Td>{inv.lotNumber}</Td>
							<Td>{inv.manufacturer}</Td>
							<Td  style={{ textAlign: "center" }}>{inv.quantity}</Td>
							
							<Td>{inv.accountLocation!==null &&
												   <>
												   {inv.accountLocation}
												   <Tooltip title={inv.location}>
									<RoomIcon style={{ color: '#5578eb',fontSize: 20}} /> 
									</Tooltip>
								
								</>
							}
							{inv.accountLocation==null && inv.location}
							</Td>
							<Td  style={{ textAlign: "center" }}>{inv.utilizedQuantity}</Td>
							<Td  style={{ textAlign: "center" }}>{inv.availableQuantity}</Td>
							<Td>{inv.approvedStatus!==null && inv.approvedStatus === false && <>

							<Tooltip
										title= "Edit Scan"
									>
																		
																		<IconButton onClick={(e) => this.handleEditDialog(inv)}>
																			<EditIcon style={{ color: '#5578eb',fontSize: 20}}/>   
																		</IconButton>
																		</Tooltip>
								 <Tooltip
										title= "Delete Scan"
									>
																		<IconButton onClick={(e) => this.handleDeleteDialog(inv)}>
																		<HighlightOffIcon style={{ color: '#5578eb',fontSize: 20}}/>   
																		</IconButton>
																		</Tooltip>

											
								
																		</>
							}
							{inv.approvedStatus!==null && inv.approvedStatus === true && 
							<>
								{'Approved'}{/* inv.approvedUserName!==null ? 'Approved By '+inv.approvedUserName : 'Approved'*/}
							</>
						
  							}
							
							</Td>
						</Tr>
						))
					}
		    </Tbody>
		     
		</Table>
		
		<div className="footer">
			   <div className="paginationInfo">
			   		<span>
			   			Displaying {((this.state.activePage-1)*this.state.pageSize)+1} to {this.state.toCount} of {this.state.totalCount}
					</span>
			   </div>
			   <div className="paginationSize">
			   		<div>Page Size&nbsp;</div> 
						<Select id="select" onChange={this.handlePageSizeChange.bind(this)} value={this.state.pageSize}>
						<MenuItem value="10">10</MenuItem>
						<MenuItem value="25">25</MenuItem>
						<MenuItem value="50">50</MenuItem>
						</Select>
			   </div>
			   <div className="paginationContainer">
				    <Pagination
						activePage={this.state.activePage}
						itemsCountPerPage={this.state.pageSize}
						totalItemsCount={this.state.totalCount}
						pageRangeDisplayed={5}
						prevPageText="<"
						nextPageText=">"
						onChange={this.handlePageChange.bind(this)}
					/>
				</div>
			</div>
		</div>
		
		
		</div>

{ this.state.selectedInventory!==null &&
<Dialog open={this.state.open} onClose={this.handleClose} aria-labelledby="form-dialog-title" maxWidth="md">
 
								<DialogTitle id="form-dialog-title">Scan Document - Approval</DialogTitle>
								<DialogContent>

									{this.state.status && (
										<div role="alert" className={"alert "+this.state.statusColor}>
										<div className="alert-text">{this.state.statusMessage}</div>
										</div>
                     				 )}
								 
								  <Formik
												   initialValues={{
													description: this.state.selectedInventory.description,
													 availableQuantity: this.state.selectedInventory.availableQuantity,
													 
												  }}
												   validate={values => {
													 const errors = {};
								 
													 if (values.description===null || values.description==="") {
													   errors.description = "This field is required";
													 }
													
								 
												 
													 if (values.availableQuantity===null || values.availableQuantity==="" ) {
													   errors.availableQuantity = "This field is required";
													 }

													 if (values.availableQuantity!=="" && parseInt(values.availableQuantity)===0 ) {
													   errors.availableQuantity = "The available quantity should not less than 1";
													 }
								 
								 
													
													 return errors;
												   }}
												   onSubmit={(values, { setStatus, setSubmitting ,setFieldValue}) => {
								 
													this.setState({loading:true});
													let postObj = {
														description: values.description,
														availableQuantity: parseInt(values.availableQuantity)
													}
								 
														   updateScan(
															 this.state.selectedInventory.id,
															 postObj 
														   )
															 .then(resp => {
															   setSubmitting(false);
															   let mes ='Your scanned document has been updated successfully.';

															   
																 let inventories = [];
																inventories = this.state.users;
																//.log("aaal locatiokns:::",locations);
																let index = inventories.findIndex(el => el.id == this.state.selectedInventory.id);
																inventories[index] = {...inventories[index], availableQuantity: values.availableQuantity};
																inventories[index] = {...inventories[index], description: values.description};
																inventories[index] = {...inventories[index], approvedStatus: true};
																this.setState({users:inventories});
																



															   //mes = mes + " Job noification has been sent to "+resp.data.split('|')[1] + ".";
																 this.setState({status:true,isSubmitting:false,loading:false,
																 statusMessage:mes ,selectedUsers:[],tguser:[],
																 alertType:'alert-success',statusColor:'alert-success'});
																 window.scrollTo(0,0);
															  
															 
															 })
															 .catch(() => {
															   setSubmitting(false);
															   this.setState({loading:false,isSubmitting:false});
															 })
														   	
								 
													
												   }}
												 >
												   {({
													 values,
													 status,
													 errors,
													 touched,
													 handleChange,
													 handleBlur,
													 handleSubmit,
													 isSubmitting,
													
												   }) => (
													 <form onSubmit={handleSubmit} noValidate autoComplete="off">
													   
										   
									 
										   <div className="kt-section">
											 <div className="kt-section__content">
											 
											  
								 
													   <div className="row">
														 <div className="col">
														   <TextField
															 margin="normal"
															 label="Product Name"
															 className="kt-width-full"
															 name="description"
															 value={values.description}
															 onChange={handleChange}
															 variant="filled"
															 helperText={errors.description}
															error={Boolean(errors.description)}
														   />
														 </div>
													   </div>    

													    <div className="row">
														 <div className="col">
														   <TextField
															 margin="normal"
															 label="Available Quantity"
															 className="kt-width-full"
															 name="availableQuantity"
															 value={values.availableQuantity}
															 onChange={handleChange}
															 variant="filled"
															 onBlur={handleBlur}
                               
															helperText={errors.availableQuantity}
															error={Boolean(errors.availableQuantity)}
														   />
														 </div>
													   </div> 
								 
													   
										  
											  
											
											   <div className="row">
												 <div className="col">
													 <button
														  disabled={isSubmitting}
														  type="submit"
															
															
														   >
														   Update & Approve
														 </button>
												 </div>
											   </div>
											
											   
											   
										 </div>
										 </div>
										 
									
								 
										 </form>
											 )}
											 </Formik>

								
								</DialogContent>
	  

								<DialogActions>
								  <Button onClick={this.handleClose} color="primary">
									Close
								  </Button>
								  
								</DialogActions>
	  
							</Dialog>
  }

  { this.state.showBulkTransfer &&
<Dialog open={this.state.showBulkTransfer} onClose={this.handleTransferClose} aria-labelledby="form-dialog-title" maxWidth="md">
 
								<DialogTitle id="form-dialog-title">Stock Transfer</DialogTitle>
								<DialogContent>

									{this.state.status && (
										<div role="alert" className={"alert "+this.state.statusColor}>
										<div className="alert-text">{this.state.statusMessage}</div>
										</div>
                     				 )}

								 {this.state.summaries !==null && this.state.summaries.length>0 && 
								 <div className="kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded" id="kt_apps_user_list_datatable">
									<InputLabel id="locationKey-label">Transfer to Location</InputLabel>
																 <Select
																  labelId="locationKey-label"
																  id="locationKey"
																  margin="normal"
																  name="locationKey"
																  className="kt-width-full"
																  style={{'width':'100%'}}
																   variant="filled"
																>
																<MenuItem value="">
																	<em>Select Location</em>
																  </MenuItem>
																  {this.state.locations.map((loc) =>(
									
																  <MenuItem key={loc.locationKey} value={loc.locationKey}>{loc.locationName}</MenuItem>
																  
																  ))}
																</Select>
												 <Table bordered>
												  <Thead>
													<Tr>
													  
													  <Th  >Description</Th>
													  <Th  >Location</Th>
													  <Th >Available Quantity</Th>
													  <Th >Transfer Quantity</Th>
													  
													  
													</Tr>
												  </Thead>
												  <Tbody>
												  {this.state.summaries.map((sum,index) => (
													<Tr style={{fontSize:14}} key={'aaa'+index}>
													 
													  <Td >{sum.description}</Td>                  
													  <Td  >{sum.accountLocation}</Td>
													  <Td  style={{ textAlign: "center" }}>{sum.availableQuantity}</Td>
													  <Td  style={{ textAlign: "center" }}><TextField
															  margin="normal"
															  className="kt-width-full"
															  type={'number'}
															  name={sum.inventoryKey}                                                     
															  onChange={(e)=>this.handleQuantityChange(e,sum)}
															  value={this.state[`summary_${sum.inventoryKey}`]}     
															  variant="outlined" 
															  InputProps={{
																inputProps: { min: 0,
																max: sum.availableQuantity,
																step: 1,
																onKeyDown: (event) => {
																  event.preventDefault();
																}, }
															  }}                     
														  /></Td>
													   
													</Tr>
													))}
													
												</Tbody>
												</Table>
												</div>
  											}
							
								 
								
								
								</DialogContent>
	  

								<DialogActions>
								  <Button onClick={this.handleTransferClose} color="primary">
									Close
								  </Button>

								   <Button
														  variant="outlined"
														  color="primary"
														  endIcon={<Icon>send</Icon>}
														
														  style={{'margin':'5px'}}
														  >
														 Trasnfer
														</Button>
								  
								</DialogActions>
	  
							</Dialog>
  }
 		
       
      </>
    );
  }
}
